import MuiTabs from '@mui/material/Tabs'
import MuiTab from '@mui/material/Tab'
import { SyntheticEvent } from 'react'
import { tabStyles, tabsStyles, tabErrorStyles } from './Tabs.styles'

type TabObject = {
  label: string
  value: number | string
}

interface TabsProps {
  tabs: TabObject[]
  onChange: (value: number | string) => void
  value: number | string
  additionalPadding?: boolean
  errorTabs?: (number | string)[]
}

function Tabs(props: TabsProps) {
  const { tabs, onChange, value, additionalPadding, errorTabs = [] } = props

  const handleChange = (_event: SyntheticEvent, newValue: number | string) => {
    onChange(newValue)
  }
  return (
    <MuiTabs
      value={value}
      onChange={handleChange}
      aria-label="basic tabs example"
      sx={{ ...tabsStyles, paddingBottom: additionalPadding ? '0.5rem' : 0 }}
    >
      {tabs.map(tab => {
        const hasError = errorTabs.includes(tab.value)
        return (
          <MuiTab
            key={tab.value}
            value={tab.value}
            label={tab.label}
            disableRipple
            sx={hasError ? { ...tabStyles, ...tabErrorStyles } : tabStyles}
          />
        )
      })}
    </MuiTabs>
  )
}

export default Tabs
